import Box from '@mui/material/Box'
import { useLocation } from 'react-router-dom'
import SingleNavLinks from './SingleNavLinks.jsx'

const NavLinks = ({ MenuLinks }) => {
  const activeUrl = useLocation()

  return (
    <>
      <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
        {MenuLinks.map((page) => (
          <SingleNavLinks
            key={page.key}
            name={page.label}
            to={page.link}
            active={activeUrl.pathname === page.link}
          />
        ))}
      </Box>
    </>
  )
}

export default NavLinks
